import _ from 'lodash';

export const RESET_REVIEWING_REPORT = "[GROUP_ADMIN] RESET_REVIEWING_REPORT";

export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT = "[GROUP_ADMIN] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START = "[GROUP_ADMIN] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS = "[GROUP_ADMIN] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR = "[GROUP_ADMIN] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR";

export const VIEW_PARKED_VISIT = "[GROUP_ADMIN] VIEW_PARKED_VISIT";
export const VIEW_PARKED_VISIT_START = "[GROUP_ADMIN] VIEW_PARKED_VISIT_START";
export const VIEW_PARKED_VISIT_SUCCESS = "[GROUP_ADMIN] VIEW_PARKED_VISIT_SUCCESS";
export const VIEW_PARKED_VISIT_ERROR = "[GROUP_ADMIN] VIEW_PARKED_VISIT_ERROR";

export const VIEW_VERIFIED_VISIT = "[GROUP_ADMIN] VIEW_VERIFIED_VISIT";
export const VIEW_VERIFIED_VISIT_START = "[GROUP_ADMIN] VIEW_VERIFIED_VISIT_START";
export const VIEW_VERIFIED_VISIT_SUCCESS = "[GROUP_ADMIN] VIEW_VERIFIED_VISIT_SUCCESS";
export const VIEW_VERIFIED_VISIT_ERROR = "[GROUP_ADMIN] VIEW_VERIFIED_VISIT_ERROR";

export const VIEW_SUBMITTED_TO_TYPIST_VISIT = "[GROUP_ADMIN] VIEW_SUBMITTED_TO_TYPIST_VISIT";
export const VIEW_SUBMITTED_TO_TYPIST_VISIT_START = "[GROUP_ADMIN] VIEW_SUBMITTED_TO_TYPIST_VISIT_START";
export const VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS = "[GROUP_ADMIN] VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS";
export const VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR = "[GROUP_ADMIN] VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR";

export const VIEW_LOCKED_VISIT = "[GROUP_ADMIN] VIEW_LOCKED_VISIT";
export const VIEW_LOCKED_VISIT_START = "[GROUP_ADMIN] VIEW_LOCKED_VISIT_START";
export const VIEW_LOCKED_VISIT_SUCCESS = "[GROUP_ADMIN] VIEW_LOCKED_VISIT_SUCCESS";
export const VIEW_LOCKED_VISIT_ERROR = "[GROUP_ADMIN] VIEW_LOCKED_VISIT_ERROR";


export const viewSubmittedForVerificationVisit = (report) => {
    return {
        type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT,
        report
    };
};

export const viewVerifiedVisit = (report) => {
    return {
        type: VIEW_VERIFIED_VISIT,
        report
    };
};

export const viewSubmittedToTypistVisit = (report) => {
    return {
        type: VIEW_SUBMITTED_TO_TYPIST_VISIT,
        report
    };
};


export const resetReviewingReport = () => {
    return {
        type: RESET_REVIEWING_REPORT,
    };
}

export const viewLockedVisit = (report) => {
    return {
        type: VIEW_LOCKED_VISIT,
        report
    };
};

export const viewParkedVisit = (report) => {
    return {
        type: VIEW_PARKED_VISIT,
        report
    };
};